export default {
  name: "app-detail-reflection",
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    leftTitle: {
      type: String,
      default() {
        return $t("8yukcv6", "钉钉组织架构");
      }
    },
    rightTitle: {
      type: String,
      default() {
        return $t("izku6b6", "绿云组织架构");
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    /*
     * 树样式处理
     */
    renderContent(h, {
      data
    }) {
      return h("span", [h("span", [data.title]), data.bindVisible && h("span", {
        "style": {
          position: "absolute",
          width: "50%",
          display: "inline-block",
          right: "0"
        }
      }, [h("span", {
        "style": {
          cursor: "default"
        }
      }, [this.renderContentRight(data)])])]);
    },
    /*
     * 树样式处理(右边树)
     */
    renderContentRight(data) {
      const h = this.$createElement;
      if (data.noBind) {
        // 关联
        if (data.disabled) {
          // 不可编辑
          return h("a", {
            "on": {
              "click": () => {}
            },
            "style": "color: #999; cursor: no-drop;"
          }, [data.bindTitle]);
        } else {
          // 可编辑
          return h("a", {
            "on": {
              "click": () => {
                this.onOpenBind(data);
              }
            }
          }, [data.bindTitle]);
        }
      } else {
        // 已关联
        if (data.disabled) {
          // 不可编辑
          return h("span", {
            "style": {
              border: "1px solid #D9D9D9",
              padding: "4px 28px 0px 9px",
              display: "inline-block",
              maxWidth: "60%",
              lineHeight: "1",
              position: "relative",
              color: "#999",
              cursor: "no-drop"
            }
          }, [h("Tooltip", {
            "attrs": {
              "content": data.bindName,
              "placement": "left",
              "max-width": "200"
            }
          }, [data.bindName])]);
        } else {
          // 可编辑
          return h("span", [h("span", {
            "style": {
              border: "1px solid #D9D9D9",
              padding: "4px 28px 0px 9px",
              display: "inline-block",
              maxWidth: "60%",
              lineHeight: "1",
              position: "relative"
            }
          }, [h("Tooltip", {
            "attrs": {
              "content": data.bindName,
              "placement": "left",
              "max-width": "200"
            }
          }, [data.bindName]), h("Icon", {
            "style": {
              position: "absolute",
              right: "5px",
              fontSize: "16px",
              color: "#ccc",
              cursor: "pointer",
              top: "2px"
            },
            "attrs": {
              "type": "md-close-circle"
            },
            "on": {
              "click": () => {
                this.$emit("on-delete-bind", data);
              }
            }
          })]), h("a", {
            "style": {
              marginLeft: "10px"
            },
            "on": {
              "click": () => {
                this.onOpenBind(data);
              }
            }
          }, [$t("e5fv2", "修改")])]);
        }
      }
    },
    /*
     * 打开映射弹窗
     */
    onOpenBind(item, type) {
      this.$emit("on-open-modal", item, type);
    }
  }
};